import { gsap } from "gsap";

export default class DynamicFont {
  constructor(element) {
    this.el = element;
    this.resizeTimer = null;
    this.maxFont = 600;

    // Churchward 69 Black specific metrics
    this.topTrimRatio = 0.12;
    this.bottomTrimRatio = 0.02;
    this.lineHeight = 0.77;

    this.init();
  }

  init() {
    this.bindMethods();

    if (document.readyState === "complete") {
      this.run();
    } else {
      window.addEventListener("load", this.run);
    }
  }

  bindMethods() {
    this.run = this.run.bind(this);
    this.calculateFontSize = this.calculateFontSize.bind(this);
    this.adjustLineHeightSpacing = this.adjustLineHeightSpacing.bind(this);
    this.onResize = this.onResize.bind(this);
  }

  run() {
    this.calculateFontSize();
    window.addEventListener("resize", this.onResize);
  }

  calculateFontSize() {
    // Find the tile inner container
    const tileInner = this.el.closest(".banner_items__tile_inner");
    if (!tileInner) return;

    // Get the tile width
    const tileWidth = tileInner.getBoundingClientRect().width;

    // Determine available width based on viewport
    const viewportWidth = window.innerWidth;
    let availableWidth;

    if (viewportWidth >= 769) {
      // 50% width on desktop
      availableWidth = tileWidth * 0.5;
    } else {
      // 100% width minus 40px total padding (20px each side) on mobile/tablet
      availableWidth = tileWidth - 40;
    }

    // Reset font size to max for accurate measurement
    // Set whiteSpace to nowrap to prevent text wrapping during measurement
    gsap.set(this.el, {
      fontSize: `${this.maxFont}px`,
      whiteSpace: "nowrap"
    });

    // Use getBoundingClientRect for precise width measurement
    const elementWidth = this.el.getBoundingClientRect().width;

    // Calculate proportional font size
    const scale = availableWidth / elementWidth;
    const newFont = this.maxFont * scale;

    // Apply the font size and line height spacing
    // Keep whiteSpace as nowrap to maintain single-line display
    gsap.set(this.el, {
      fontSize: `${newFont}px`
    });

    this.adjustLineHeightSpacing(newFont);
  }

  adjustLineHeightSpacing(fontSize) {
    const topTrim = fontSize * this.topTrimRatio;
    const bottomTrim = fontSize * this.bottomTrimRatio;

    // Determine position in heading
    const isFirstLine = this.el.classList.contains("line-1");
    const isLastLine = this.el.classList.contains("line-2");

    // Apply spacing based on position
    gsap.set(this.el, {
      lineHeight: this.lineHeight,
      marginTop: isFirstLine ? `-${topTrim}px` : 0,
      marginBottom: isLastLine ? `-${bottomTrim}px` : 0,
      display: "block",
    });

    // Mark slide-content as ready to fade in (prevents FOUT)
    const slideContent = this.el.closest(".slide-content");
    if (slideContent) {
      slideContent.classList.add("content-ready");
    }
  }

  onResize() {
    clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(() => {
      this.calculateFontSize();
    }, 200);
  }

  destroy() {
    window.removeEventListener("resize", this.onResize);
    window.removeEventListener("load", this.run);
  }
}
